import React from "react"
import AllTabPanel from "../../entities/hiring/ui/tabPanel/AllTabPanel"
import Box from "@mui/material/Box"

const Hiring = () => {
  return (
    <Box sx={{ mx: "10px", mt: "10px" }}>
      <AllTabPanel />
    </Box>
  )
}

export default Hiring
